module.exports = __webpack_public_path__ + "static/img/23-riskmanagement.758caa4.png";


//////////////////
// WEBPACK FOOTER
// ./static/Icon/23-riskmanagement.png
// module id = Uqfa
// module chunks = 1